/*******************************************************************************
  SelectTenant.js

  Author: Advait
*******************************************************************************/

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTenants } from "../apihelpers/graphqlhelpers";
import { setTenant } from "../store/siteSlice";
import { setTenants } from "../store/tenantSlice";
import "../index.css";

function SelectTenant() {
  const dispatch = useDispatch();
  const selectedTenantId = useSelector((state) => state.selectedSite.tenantId);
  const tenantList = useSelector((state) => state.tenantList.tenants);
  useEffect(() => {
    async function refreshFromDB() {
      let tenants = await getTenants(false); //TODO add a way to see disabled tenants
      dispatch(setTenants(tenants));
      if (tenants.length === 1) {
        dispatch(setTenant(tenants[0].id));
      }
    }
    //TODO fetch from DB only if we don't already have tenant info?
    refreshFromDB();
  }, [dispatch]);

  function handleSelectedTenant(event) {
    const tenantid = event.target.value;
    dispatch(setTenant(tenantid));
  }

  //***************************************************************************
  // render the UI
  //***************************************************************************
  if (tenantList.length <= 1) {
    return <div></div>;
  } else {
    const allTenants = [].concat(tenantList).map((tenant, i) => {
      return (
        <option key={i} value={tenant.id}>
          {tenant.company}
        </option>
      );
    });
    return (
      <div className="individualContainer">
        <table className="individualContainerTable">
          <tbody>
            <tr>
              <td className="individualContainerTitleColumn" valign="top">
                <h4 className="individualContainerTitleHeading">Tenant Selection</h4>
              </td>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td className="individualContainerSubTitleColumn">
                        <h6>Select Tenant to Manage</h6>
                      </td>
                      <td>
                        <select
                          className="inputFieldSelect"
                          value={selectedTenantId}
                          onChange={handleSelectedTenant}
                        >
                          <option value="">-- Please Choose a Tenant --</option>
                          {allTenants}
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}
export default SelectTenant;
